export default __webpack_public_path__ + "static/media/masked-image-hover-icon.801c85e9.svg";